/** Lorem ipsum words — cycled to match target character length. */
const LOREM =
  'Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur Excepteur sint occaecat cupidatat non proident sunt in culpa qui officia deserunt mollit anim id est laborum';

const SHV_CLONE_MARKERS =
  /shareholder\s*value|frankfurter|modern\s*value|ucits-etf|wertentwicklung\s*seit\s*auflage/i;

export function isShvCloneText(value: unknown): boolean {
  if (value == null || value === '') return false;
  return SHV_CLONE_MARKERS.test(String(value));
}

export function isAlreadyLorem(value: unknown): boolean {
  return /^lorem ipsum/i.test(String(value ?? '').trim());
}

/** Replace text with lorem ipsum of approximately the same length (word boundaries). */
export function loremIpsumOfLength(length: number): string {
  if (length <= 0) return '';
  const words = LOREM.split(/\s+/);
  const parts: string[] = [];
  let total = 0;
  let i = 0;
  while (total < length && parts.length < words.length * 3) {
    const word = words[i % words.length];
    const next = parts.length ? ` ${word}` : word;
    if (total + next.length > length + 12 && parts.length > 3) break;
    parts.push(parts.length ? word : word);
    total += next.length;
    i += 1;
  }
  let result = parts.join(' ');
  if (result.length > length + 20) {
    result = result.slice(0, length).replace(/\s+\S*$/, '').trim();
  }
  return result;
}

export function loremIpsumPlaceholder(source: unknown): string {
  const raw = String(source ?? '').trim();
  if (!raw) return '';
  if (isAlreadyLorem(raw)) return raw;
  return loremIpsumOfLength(raw.length);
}

/**
 * Replace SHV-clone leftovers with length-matched Lorem.
 * Never overwrite real editor content (or intentional Lorem) on save/reload.
 */
export function applyPvmLoremPlaceholders(v2: Record<string, unknown>): void {
  const textFields = [
    'investmentphilosophie',
    'strategie',
    'chancen',
    'risiken',
    'ethik',
    'fussnote',
    'disclaimer',
  ] as const;

  for (const key of textFields) {
    const val = v2[key];
    if (typeof val === 'string' && val.trim() && isShvCloneText(val)) {
      v2[key] = loremIpsumPlaceholder(val);
    }
  }

  const commentary = v2.monthlyCommentary as { left?: string; right?: string } | string | undefined;
  if (commentary && typeof commentary === 'object' && !Array.isArray(commentary)) {
    if (commentary.left?.trim() && isShvCloneText(commentary.left)) {
      commentary.left = loremIpsumPlaceholder(commentary.left);
    }
    if (commentary.right?.trim() && isShvCloneText(commentary.right)) {
      commentary.right = loremIpsumPlaceholder(commentary.right);
    }
    v2.monthlyCommentary = commentary;
  } else if (Array.isArray(v2.intro) && v2.intro.length >= 2) {
    v2.intro = v2.intro.map((block: unknown) => {
      const s = String(block ?? '').trim();
      if (!s || !isShvCloneText(s)) return block;
      return loremIpsumPlaceholder(s);
    });
  }

  // Keep intro[] in sync when monthlyCommentary is the source of truth
  if (commentary && typeof commentary === 'object' && !Array.isArray(commentary)) {
    const left = commentary.left?.trim() || '';
    const right = commentary.right?.trim() || '';
    if (left || right) {
      v2.intro = [left, right];
    }
  }
}
